import React from 'react';
import { Helmet } from 'react-helmet';
import { MdDelete } from 'react-icons/md';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import ActiveTableRowsExistGate from 'components/ActiveTableRowsExistGate';
import MultipleActiveTableRowsExistGate from 'components/MultipleActiveTableRowsExistGate';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
import ResetSelectedTableCellsOnEntityTypeUpdate from 'components/ResetSelectedTableCellsOnEntityTypeUpdate';
// @ts-ignore
import EntityTypeName from 'components/EntityTypeName';
import RoleButton from 'components/RoleButton';
import RoleModal from 'components/RoleModal';
import VirtualizedTableBulkEditButton from 'components/VirtualizedTableBulkEditButton';
import { CREATE_MODAL_QUERY_STRING_PARAM } from 'components/VirtualizedTable/constants';

import { ADMIN } from 'components/RoleGate/constants';
import EntitiesArchiveForm from './components/EntitiesArchiveForm';
import EntitiesSaveMessage from './components/EntitiesSaveMessage';
import EntitiesVirtualizedTable from './components/EntitiesVirtualizedTable';
import { ENTITIES_ARCHIVE_MODAL_PARAM } from './constants';

const { REACT_APP_PROJECT_NAME } = process.env;

interface Props {
    match: {
        params: {
            entityTypeId: string;
        };
    };
}

export class Entities extends React.PureComponent<Props> {
    get entityTypeId(): number {
        const { match } = this.props;
        const { entityTypeId } = match.params;
        return Number(entityTypeId);
    }

    render(): React.ReactElement {
        return (
            <ErrorBoundary
                namespace="Entities"
                FallbackComponent={<ErrorBoundaryAlert />}
            >
                <Helmet>
                    <title>Areas - {REACT_APP_PROJECT_NAME}</title>
                </Helmet>
                <ResetSelectedTableCellsOnEntityTypeUpdate
                    entityTypeId={this.entityTypeId}
                />
                <PageTitleAndFilters
                    title={
                        <EntityTypeName
                            entityTypeId={this.entityTypeId}
                            plural
                        />
                    }
                    searchInputPlaceholder="Search"
                    FirstActionButton={
                        <MultipleActiveTableRowsExistGate>
                            <VirtualizedTableBulkEditButton
                                requiredRoles={[ADMIN]}
                            />
                        </MultipleActiveTableRowsExistGate>
                    }
                    SecondActionButton={
                        <ActiveTableRowsExistGate>
                            <RoleButton
                                requiredRoles={[ADMIN]}
                                params={{
                                    [ENTITIES_ARCHIVE_MODAL_PARAM]: true
                                }}
                                buttonProps={{
                                    icon: true,
                                    color: 'black',
                                    basic: true,
                                    style: {
                                        marginRight: 0,
                                        marginLeft: 8
                                    }
                                }}
                            >
                                <ButtonIconWrapper>
                                    <MdDelete
                                        style={{
                                            fontSize: 20
                                        }}
                                    />
                                </ButtonIconWrapper>
                                Archive
                            </RoleButton>
                        </ActiveTableRowsExistGate>
                    }
                    ThirdActionButton={
                        <RoleButton
                            requiredRoles={[ADMIN]}
                            params={{
                                [CREATE_MODAL_QUERY_STRING_PARAM]: true
                            }}
                            buttonProps={{
                                secondary: true,
                                style: {
                                    marginRight: 0,
                                    marginLeft: 8
                                }
                            }}
                        >
                            Create New
                        </RoleButton>
                    }
                    currentEntity
                    currentSeason
                    hideFilters
                    MessageComponent={<EntitiesSaveMessage />}
                />
                <PageTitleAndFiltersPusher>
                    <EntitiesVirtualizedTable
                        tableId={`entityType-${this.entityTypeId}`}
                        entityTypeId={this.entityTypeId}
                    />
                </PageTitleAndFiltersPusher>
                <RoleModal
                    requiredRoles={[ADMIN]}
                    param={ENTITIES_ARCHIVE_MODAL_PARAM}
                >
                    <EntitiesArchiveForm entityTypeId={this.entityTypeId} />
                </RoleModal>
            </ErrorBoundary>
        );
    }
}

export default Entities;
